// // @ts-ignore
import {state} from './states';

export const user = () => state.user;
